module.exports = __webpack_public_path__ + "static/media/switch-profile.e3f32c49.svg";